module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As a small boy, I was fascinated by stories of the Battle of Britain, with models of Spitfires and Hurricanes hanging from my bedroom ceiling, daily engaged once more in defending our nation from invasion. How could I have ever imagined that many years later I would have the immense privilege of counting members of Churchill’s ‘Few’ as friends. As an RAF Chaplain I had long been involved with Battle of Britain events, but nothing could surpass being with ‘The Few’ at Memorial Day at Caple Le Fern, or Battle of Britain Sunday at Westminster Abbey.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now those models on my ceiling had become real men, real heroes, claiming to be ordinary men and yet having done extraordinary things. It is all too easy to think of the ‘great names’ whose stories are recounted, but as Dilip Sarkar so skilfully reminds us in this book the Battle was fought and won by more than just those featured in the headlines.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In my growing relationship with ‘The Few’, (as Chaplain to the Battle of Britain Fighter Association) I learned so much from these ‘ordinary’ men who counted themselves not as heroes but as having simply done their duty. However, I also learned of the ‘Human Cost’ amongst those we call ‘The Few’ – hence why I am delighted that this book deals with this difficult and challenging theme.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To those of the Few who survived, the heroes of the Battle were those whose names are inscribed in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Battle of Britain Roll of Honour -")]), _vm._v(" which until recently those august survivors escorted in to the Abbey on Battle of Britain Sunday. Now, their successors, todays fighter pilots, represent them as they parade the Roll of Honour - a book of names, which is an aid to remembrance, but behind every name is an ever-increasing circle of those who are part of the Human Cost of such a Battle. Parents, wives, children, friends, colleagues all pay the cost when someone they love dies in conflict, and they do not forget. Neither should we.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book helps us to do exactly that, by going behind the names, giving these men back their story. Dilip Sarkar’s meticulous research puts both the ordinariness and extra-ordinariness of these men centre stage. He captures something of their personalities, their skill, and sense of duty and this helps us remember ‘The Few’ as they were. History is not just about events. It is also about people - and people are my business - and this is a book about people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For anyone who is interested in the Battle of Britain, it is a ‘must read’ for it goes beyond the strategy and those wonderful aircraft to reveal the ‘Human Cost’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is a book that is long overdue, and I am grateful for the opportunity in writing this foreword to once again say ‘Thank you’ to those we call the ‘Few’ and ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("who by their valour and sacrifice did nobly save their day and generation’.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Venerable Ray J Pentland CB")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Honorary Chaplain to The Battle of Britain Fighter Association")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Group Captain Patrick Tootal OBE DL RAF (Ret’d)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Honorary Secretary")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Battle of Britain Fighter Association")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Battle of Britain Memorial Trust")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0viii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Venerable Ray Pentland and the author at Wing Commander JFD ‘Tim’ Elkington’s Memorial Service, 11 May 2019.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f00ix-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Group Captain Patrick Tootal with the author and Martin Mace of Frontline Books/Pen & Sword, at the opening of Nicolson House in Southampton, commemorating Flight Lieutenant James Brindley Nicolson VC, on 19 October 2018.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f00ix-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Group Captain Patrick Tootal OBE DL, a former Hercules pilot now Honorary Secretary of the BoBFA and BoBMT - whose father was sadly a wartime pilot killed on operations with Bomber Command (Patrick Tootal).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e812272","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Foreword.vue
// module id = 72
// module chunks = 0